import { UserAvatar, isRealPhoto } from '../ui/UserAvatar';

export { isRealPhoto };

export function hasFotoReal(fotoUrl?: string | null): boolean {
  return isRealPhoto(fotoUrl);
}

/** Avatar circular unificado: foto ou iniciais/gradiente via UserAvatar (lista / cards / painéis laterais) */
export function ListAvatar({
  fotoUrl,
  nome,
  size = 28,
  role,
}: {
  fotoUrl?: string | null;
  nome: string;
  size?: number;
  role?: string | null;
}) {
  return (
    <UserAvatar
      src={fotoUrl}
      name={nome}
      role={role}
      size={size}
    />
  );
}
